import { render, staticRenderFns } from "./badsphf.vue?vue&type=template&id=6fc9cff6&scoped=true&"
import script from "./badsphf.vue?vue&type=script&lang=js&"
export * from "./badsphf.vue?vue&type=script&lang=js&"
import style0 from "./badsphf.vue?vue&type=style&index=0&id=6fc9cff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9cff6",
  null
  
)

export default component.exports